import { Grid, styled } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { ContactAddressSchema } from "../../../../hooks/ContactRelatedApiZodSchema";
import { useSelector } from "react-redux";
const TitleStyle = styled(Grid)({
  background: " #EBEDF3",
  // textTransform: "capitalize",
  padding: "5px 10px",
  fontSize: "13px",
  fontWeight: 500,
  color: "#131313",
});

const DescriptionStyle = styled(Grid)({
  // textTransform: "capitalize",
  padding: "5px 10px",
  fontSize: "13px",
  fontWeight: 500,
  color: "#131313",
});
interface AddressComponentProps {
  contact: ContactAddressSchema;
  defaultAddressHandler: (id: number) => void;
  // countryName: string;
  // stateName: string;
  // cityName: string;
}


const AddressComponent = ({
  contact,
  defaultAddressHandler,
  // countryName,
  // stateName,
  // cityName,
}: AddressComponentProps) => {
  const ContactDetailsvatNo = useSelector(
    (state: any) => state.contactGeneralDetails.ContactDetails.vatNo
  );
  const sessionList = useSelector(
    (state: any) => state.sessionData.sessionScope
  );
  const taxtype = window.location.href.includes("customers")
    ? !ContactDetailsvatNo?.trim()
      ? "gst"
      : "vat"
    : sessionList?.governmentTaxType || "gst";
  return (
    <Grid item lg={4}>
      <Grid
        container
        item
        lg={12}
        style={{ border: "1px solid #EBEDF3", marginBottom: "10px" }}
      >
        <Grid
          item
          lg={4}
          xs={4}
          style={{
            padding: 0,
            background: "#EBEDF3",
            fontSize: "13px",
            fontWeight: "500",
            color: "#131313",
          }}
        ></Grid>
        <Grid
          item
          lg={8}
          xs={8}
          style={{
            padding: 0,
            background: " #EBEDF3",
            textAlign: "right",
            fontSize: " 13px",
            fontWeight: "400",
            color: "#808080",
          }}
        >
          {" "}
          <FormControl>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              defaultValue="female"
              name="radio-buttons-group"
            >
              {contact.isDefault === 1 ? (
                <FormControlLabel
                  checked={Boolean(contact.isDefault)}
                  sx={{
                    color: "#00A4E5",
                    '& .MuiFormControlLabel-label': {
                      fontFamily: "Plus Jakarta Sans,sans-serif",
                    },
                  }}
                  value="default"
                  control={<Radio />}
                  label="Default"
                  onChange={(_e) =>
                    contact.contactAddressId &&
                    defaultAddressHandler(contact.contactAddressId)
                  }
                />
              ) : (
                <FormControlLabel
                  checked={Boolean(contact.isDefault)}
                  value="set as default"
                  control={<Radio />}
                  sx={{
                    color: "#00A4E5",
                    '& .MuiFormControlLabel-label': {
                      fontFamily: "Plus Jakarta Sans,sans-serif",
                    },
                  }}
                  label="Set As Default"
                  onChange={(_e) =>
                    contact.contactAddressId &&
                    defaultAddressHandler(contact.contactAddressId)
                  }
                />
              )}
            </RadioGroup>
          </FormControl>
        </Grid>
        <TitleStyle style={{fontWeight:'bold'}} item lg={4} xs={5}>
          First Name
        </TitleStyle>
        <DescriptionStyle item lg={8} xs={7}>
          {contact.contactFirstName || "-"}
        </DescriptionStyle>
        <TitleStyle style={{fontWeight:'bold'}} item lg={4} xs={5}>
          Last name
        </TitleStyle>
        <DescriptionStyle item lg={8} xs={7}>
          {contact.contactLastName || "-"}
        </DescriptionStyle>
        <TitleStyle style={{fontWeight:'bold'}} item lg={4} xs={5}>
          Company Name
        </TitleStyle>
        <DescriptionStyle item lg={8} xs={7}>
          {contact.contactCompanyName || "-"}
        </DescriptionStyle>
        <TitleStyle style={{fontWeight:'bold'}} item lg={4} xs={5}>
          Mobile No.
        </TitleStyle>
        <DescriptionStyle item lg={8} xs={7}>
          {contact.phoneNo || "-"}
        </DescriptionStyle>
        <TitleStyle style={{fontWeight:'bold'}} item lg={4} xs={5}>
          Email
        </TitleStyle>
        <DescriptionStyle item lg={8} xs={7}>
          {contact.email || "-"}
        </DescriptionStyle>
        {/* <TitleStyle style={{fontWeight:'bold'}} item lg={4} xs={5}>
          PAN No.:
        </TitleStyle>
        <DescriptionStyle item lg={8} xs={7}>
          {contact.panNo || "-"}
        </DescriptionStyle> */}
        {taxtype !== "vat" && (
          <>
            <TitleStyle style={{fontWeight:'bold'}} item lg={4} xs={5}>
              GST Type
            </TitleStyle>
            <DescriptionStyle item lg={8} xs={7}>
              {contact.gstType || "-"}
            </DescriptionStyle>
            <TitleStyle style={{fontWeight:'bold'}} item lg={4} xs={5}>
              GSTIN
            </TitleStyle>
            <DescriptionStyle item lg={8} xs={7}>
              {contact.GSTIN || "-"}
            </DescriptionStyle>
          </>
        )}
        <TitleStyle style={{fontWeight:'bold'}} item lg={4} xs={5}>
          Address Line 1
        </TitleStyle>
        <DescriptionStyle item lg={8} xs={7}>
          {contact.addressLine1 || "-"}
        </DescriptionStyle>
        <TitleStyle style={{fontWeight:'bold'}} item lg={4} xs={5}>
          Address Line 2
        </TitleStyle>
        <DescriptionStyle item lg={8} xs={7}>
          {contact.addressLine2 || "-"}
        </DescriptionStyle>
        <TitleStyle style={{fontWeight:'bold'}} item lg={4} xs={5}>
          Country
        </TitleStyle>
        <DescriptionStyle item lg={8} xs={7}>
          {contact.countriesName || "-"}
        </DescriptionStyle>
        <TitleStyle style={{fontWeight:'bold'}} item lg={4} xs={5}>
          State
        </TitleStyle>
        <DescriptionStyle item lg={8} xs={7}>
          {contact.stateName || "-"}
        </DescriptionStyle>
        <TitleStyle style={{fontWeight:'bold'}} item lg={4} xs={5}>
          City
        </TitleStyle>
        <DescriptionStyle item lg={8} xs={7}>
          {contact.cityName || "-"}
        </DescriptionStyle>
        <TitleStyle style={{fontWeight:'bold'}} item lg={4} xs={5}>
          ZIP/Postal Code
        </TitleStyle>
        <DescriptionStyle item lg={8} xs={7}>
          {contact.pinCode || "-"}
        </DescriptionStyle>
      </Grid>
    </Grid>
  );
};
export default AddressComponent;
